import {
  DEFAULT_DEPOSITS_FILTERS,
  DEFAULT_WITHDRAWALS_FILTERS
} from '@bo-constants/filters';
import type { DateRange } from '@library/types/dates';
import { DateTime } from 'luxon';
import type { FilterKey } from '@library/types/filters';
import { SELECT_ALL } from '@library/component-utils/filters';
import { isTimeAfter } from '@library/utils/dateTime';
import { useState } from 'react';

export function usePaymentsFilters() {
  const beginOf2024 = DateTime.fromISO('2024'); // January 1, 2024
  const [selectedStartDate, setSelectedStartDate] =
    useState<DateTime>(beginOf2024);
  const [selectedEndDate, setSelectedEndDate] = useState<DateTime>(
    DateTime.now()
  );
  const [searchValue, setSearchValue] = useState('');

  const handleSelectDateRange = (value: DateRange) => {
    const { fromDate: newFromDate, toDate: newToDate } = value;

    const newSelectedEndDate =
      newToDate &&
      isTimeAfter({ dateValue: newFromDate, dateToCompareAgainst: newToDate })
        ? newFromDate
        : newToDate;

    setSelectedStartDate(newFromDate);
    setSelectedEndDate(newSelectedEndDate);
  };

  const fromDate = selectedStartDate.toJSON() ?? '';
  const toDate = selectedEndDate.toJSON() ?? '';

  const handleSearch = (value: string) => {
    setSearchValue(value);
  };

  const [depositsFilters, setDepositsFilters] = useState(
    DEFAULT_DEPOSITS_FILTERS
  );

  const changeDepositsFiltersValue = (
    filterKey: FilterKey,
    value: string | Array<string>
  ) => {
    const newFilterState = {
      ...depositsFilters,
      [filterKey]: value
    };

    setDepositsFilters(newFilterState);
  };

  const [withdrawalsFilters, setWithdrawalsFilters] = useState(
    DEFAULT_WITHDRAWALS_FILTERS
  );

  const changeWithdrawalsFiltersValue = (
    filterKey: FilterKey,
    value: string | Array<string>
  ) => {
    const newFilterState = {
      ...withdrawalsFilters,
      [filterKey]: value
    };

    setWithdrawalsFilters(newFilterState);
  };

  const resetFilters = () => {
    setDepositsFilters({
      ...depositsFilters,
      depositStatus: SELECT_ALL,
      depositMethodType: SELECT_ALL
    });
    setWithdrawalsFilters({
      ...withdrawalsFilters,
      withdrawalStatus: SELECT_ALL,
      withdrawalMethod: SELECT_ALL
    });
    setSelectedStartDate(DateTime.now());
    setSelectedEndDate(DateTime.now());
  };

  return {
    fromDate,
    handleSearch,
    handleSelectDateRange,
    resetFilters,
    searchValue,
    selectedEndDate,
    selectedStartDate,
    toDate,
    changeDepositsFiltersValue,
    depositsFilters,
    setDepositsFilters,
    changeWithdrawalsFiltersValue,
    withdrawalsFilters,
    setWithdrawalsFilters
  };
}
